import IPixelMapDay from "@interfaces/pixel-map-day.interface";

const octoberMap: Array<IPixelMapDay> = [
	{
		status: "awful",
		title: "Give Me a Time Machine",
		icon: "history",
		reason: `
			Today seemed like an okay day, or at least it initially did.

			I also watched Mask Girl until the 4th episode. By the evening, I got to play Stardew Valley with my friends again, surprisingly.

			While I was thinking of that, I suddenly got reminded of Jaze, Angela, my past IMC friends, and even the RC. People I thought I had strong bonds with, people who I thought would stay in my life forever. To this day, I miss them. I miss my friends. I miss having a person I could always confide in.

			I just cried and I cried because 2023 has been **the worst** year of my life yet, way worse than the year I dropped out of college. I lost so many friends and experienced no growth at all. I'm stuck in my same position, and I'm stuck with my friends who can just leave at the drop of a hat. I miss having my friends I can feel safe with. My friends whose shoulders I can lean on and tell things to, without the fear of them making fun of me afterward or spreading my secrets to everyone, unlike my friends and some of my current friends.

			In my sadness, I went to the place Jaze and I often went to—the streets along Venice Grand Plaza. I cried so much there, it was the most I've cried in such a long time. I still miss my friends. I still regret everything.

			They say that you pick your own battles and I chose the wrong one. If I could go back to 2021 and reset everything, I would. A time before my life came crashing down in 2022. To a time where people wanted to hang out with me simply because I was myself. I almost had everything back then, and I thought that if I pursued 1 more thing, I would be complete. I didn't know that, if I went on this struggle, I would lose everything and gain nothing.

			Aaaaah, it hurts, it hurts. I just kept crying and crying while I was outside. I had to make it back by 11:45, which I did, but my feelings still lingered. I'm unfortunately here, and I've lost everything near and dear to me 2 years ago. I honestly don't know if I'll **ever** find people whom I can confide with on that deep of a level again. I genuinely hate my life and I want another shot at redemption so badly.
		`,
		spotify: {
			song: "Time Machine",
			artist: "Girls' Generation",
			link: "https://open.spotify.com/track/01DWHWYLvPOo1VwidHhza8?si=3cb3865ec1484fe0",
			album: "Re:package Album “GIRLS’ GENERATION”～The Boys～"
		},
		resonatedLyrics: [
			"It's over, guess it's over",
			"...",
			"One mistake, got a one regret",
			"...",
			"Gimme a time machine",
			"Oh, gimme a time machine",
			"Oh, gimme a time machine",
		]
	},
	{
		status: "special",
		title: "What the Hell?",
		icon: "indeterminate_question_box",
		reason: `
			What the hell? Today was pretty weird. My dad came back to our house after **years** of us seeing not him. My morning routine was nothing out of the ordinary. Around the afternoon was when things started to take a turn for the strange.

			I'm still sad about things, so I cried about it. I tried to hide it as best I can, but my friends definitely noticed. I eventually lied on my bed to cry and think about my past friends.

			Out of nowhere, I got a call from an unknown number and it turned out to be from my dad. He was waiting outside with a bunch of Krispy Kreme boxes. My sister and I hadn't seen him in years and it was pretty shocking to see him standing outside our house.

			It was the usual shtick with dad. He asked us about how life was and then asked us again to seriously move to Australia with him. My sister and I are honestly not buying it because he has a habit of helping us only on his own terms and conditions. His plan for us to move to Australia wasn't clear either. For a while, we entertained the idea, but both of us were really worried and scared at the opportunity he presented.

			I went back to working because the conversation wasn't really going to go anywhere. I told my friends what had happened and they were concerned but also surprised at how drama would unfold.

			I guess it's good that I was able to have a conversation with my friends about this. I was really confused and they offered a lot of sensible advice and things I can think of.
			
			When I said that I wanted the past to come back, I didn't mean *this* past. I wanted **my friends** back, not my dad.
		`,
		spotify: {
			song: "Memories",
			artist: "Maroon 5",
			link: "https://open.spotify.com/track/4cktbXiXOapiLBMprHFErI?si=7aee3188ecd64227",
			album: "JORDI (Deluxe)"
		},
	},
	{
		status: "good",
		title: "It Started with the Big Bang",
		icon: "science",
		reason: `
			I watched The Big Bang Theory with my friends today, it helped me go through most of the day. This was another pretty weird day for me, surprisingly. With my guy best friend calling me and then I had to talk to the girl he fumbled up things with.

			Work continued as normal but I decided that I can't rely on my father for helping me because he's been an absentee for this long and he has a horrible track record of only helping at his own terms. So I decided to take a loan from work. Here's to hoping that I can still help myself get through this.

			Around evening, I was able to play Stardew Valley with my friends again. Our farm was still in winter but we had progressed quite a lot in the game. I just slept the night off but thankfully enjoyed a pretty fun and lighthearted day.
		`,
	},
	{
		status: "special",
		title: "Mom Comes Home",
		icon: "flight_land",
		reason: `
			Mom came home today. It feels like it's been a while even though we only had their back last December. Things were pretty okay in the house. We had a lot of chocolates and stuff they brought back. We also had a lot of food today to celebrate.

			I also gave my hotel tickets to my mom and sister so they can enjoy a fun day tomorrow.
		`,
		spotify: {
			artist: "aespa",
			album: "MY WORLD - The 3rd Mini Album",
			song: "'Til We Meet Again",
			link: "https://open.spotify.com/track/60Uio68M57PwKEgZxSutL6?si=5c1a91d89c7045ef"
		}
	},
	{
		status: "above-average",
		reason: `
			Mom and my sister were mostly out for the day, so it was just me being alone at our part of the house for today.

			I declined to give my friends breakfast, so I felt guilty and then I decided something. I decided to get Taylor Swift's "Midnights" album to my friends as a gift. We both like You're Losing Me, so I decided to get them the Late Night edition. I also decided to gift chocolates because why not. Around lunchtime, I got chocolates but I got home soaked from the pouring rain.

			Around evening, when they were going to get the chocolates. They were mostly anxious for that day, but they appreciated the gift regardless.

			I had nothing to do so I just watched some trashy reality show TV commentary on YouTube while eating Indian food. The food was really nice, but also very spicy.
		`,
		spotify: {
			song: "Snoop Dogg",
			artist: "Young, Wild & Free (feat. Bruno Mars)",
			link: "https://open.spotify.com/track/5HQVUIKwCEXpe7JIHyY734?si=cc38182c5d564eaa",
			album: "Young, Wild & Free (feat. Bruno Mars)"
		},
	},
	{
		status: "above-average",
		reason: `
			It was day 2 of me mostly being at home again today. Around morning, I was mostly busy with work and my deliverables. Meetings, updates, and DevOps things. The usual day-to-day with work.
			
			Mom and my sister arrived back home after the evening and, by then, I feel like I ate **a lot**, even though it was just bacon 🥓.

			But around evening, I mostly played an old game that I used to like a lot back then: *Thrillville: Off the Rails*. It was nice playing it on my PC and using the PS5 controller. For some parts of the evening, I was able to play Phasmophobia with my friends again, too. We lost a few games as usual, but won some and it was pretty fun.

			For some reason, I felt like I had a lot of time today. Like, *a lot of time*. This week has been incredibly weird.

			Also, I watched the 1st episode of Loki season 2. I loved it! I can't wait for the next episode airing next week.
		`,
	},
	{
		status: "excellent",
		icon: "joystick",
		title: "Wangan Racing",
		reason: `
			Today was *finally* the day I've been waiting for: the day I go to the arcades and play Wangan Midnight!

			Nothing much happened during the start of the morning, I barely remember much happening aside from changing my decision to eat samgyupsal alone and instead eating the salmon my mom cooked. It was really nice, all things considered. They served several pieces of salmon. After eating, I was mostly done with things to do at home and then went on to the aracde in Bonifacio High Street.

			I finally got to play Wangan Midnight! It's been so long since I've played a proper game of it and I'm glad my Banapassport worked. I got to register my old "main" car: the Nissan Fairlady Z Version ST. I thought the story of Wangan Midnight 6 RR would be different but it's exactly the same story as the one I played at home.

			Playing for hours was really fun! But there was 1 time where I had to give away my seat to my friends because the arcade machine next to me was busted, and I saw people who really, really wanted to play the game. After that, it was mostly me playing the arcade and progressing through the story while playing songs from Spotify.

			There were some matches that I won against some people, but I often had to lose against some newbies and people just casually playing the arcade. I got to face off against this kid who mistakenly matched against me and he looked so happy when he won. There was also this other kid who had his dad watch behind him and apologized to me when I matched against him. Thankfully, for both kids, I let them win. I wanted them to have a fun, exciting game.

			Anyway, since I was already in BGC, I was able to **finally** try out the 8cuts burger restaurant since my friends said it was their favorite brand of burger. Honestly, I've had a lot of burgers in my time but the best definitely was 8cuts. I did some other stuff in the night and that pretty much summed up an excellent day for me.
		`,
		spotify: {
			artist: "NewJeans",
			album: "NewJeans 2nd EP 'Get Up'",
			song: "ASAP",
			link: "https://open.spotify.com/track/5fpyAakgFOm4YTXkgfPzvV?si=8c05d33dadde40ef"
		},
	},
	{
		status: "good",
		reason: `
			I'm very anxious for what'll happen today. I'll be having dinner with dad and some of his relatives, including his current wife and sons. I'm not sure what to feel about it aside from a general awkwardness, honestly. But I woke up and got to keep up with my friends to start the morning, and I got to talk with my family members here, too.

			Around before lunch, my friends messaged me to play Stardew Valley with them and I got to spend a lot of time in game with them. They were fun to talk to, it was the usual: just us telling each other things that's been going on with our lives. We also played The Forest and got back to killing the cannibals in the game, even though my save file was deleted. We both ended the game and play again after I was called to prepare to go out.

			Then I went with my sister and mom to the mall we were supposed to meet at, then mom shortly left to do their own thing at a different mall far away. It was just my sister and I meeting the other side of our family. We got to meet dad and his eldest son. I got to socialize with him for a bit and ask him about things. He looked pretty mature for a 13-year-old kid. Then we meet the other members of dad's family that we've grown apart from.

			Dinner was pretty nice, the buffet was great ~~and it's been a while since I've been to one~~. Or, wait, never mind, I've just been to one 2 weeks ago. But their selection of food was really **a lot**, honestly. I think I've mastered the art of the buffet and ate quite a lot that seemed really expensive. This was going on while my sister was trying to hold conversations with the other members of my family and even dad's current wife. I'm surprised because they seemed more extroverted than I am. The usual catching up also happens: conversations about life, love life, that one time I cosplayed as Emilia from Re:Zero, the usual stuff.

			For one time, I got to talk to my dad about moving to Australia.

			My stance still remains the same, I'm not going. His current plan still sucks, he wants me to live with his current family under his roof. After going through some major, traumatic shit in college about *the same thing* (living under a stranger's roof), I was having none of that shit. He kept assuring me that he won't leave me there, that he's my dad and that he's no stranger. But he is, though. He's an estranged father trying to make amends at this late stage in our lives. Regardless, I'm not going to uproot my life for some stranger. I have no safety net there. What if the same shit from the past happens and I get traumatized? In a foreign country, with no people to run to? Fuck that. I denied his request and I think he got pissed off a little. We didn't really reach a deal and that was that.

			My sister and I got to walk around after saying goodbyes and we talked about our experience. I'm lucky to have arrived home to mom and I was able to have my friends listen to me talk about how my day went, even though it seemed extremely weird. We got to play Stardew and talk as usual. It was nice, all things considered. This isn't the level of closeness my dad wants our family to be, but this is the most optimal, given the current situations. We could've been more hostile, but we're friendly and courteous at this level of distance. I think that's good enough.

			I'm settled on my plans for the future: stay here in the Philippines and build a life here. I'm going to write my own story.

			### PS
			This week has been strange and kinda horrible, but I'm glad I had my friends stable throughout most of it. I'm still sad about the friends I lost and the pain of losing them, and my current song for the day really reflects that. I'm happy, though, for the people still there.
		`,
		spotify: {
			artist: "Taylor Swift",
			song: "I Almost Do (Taylor’s Version)",
			link: "https://open.spotify.com/track/2r9CbjYgFhtAmcFv1cSquB?si=57e236b68f7c4510",
			album: "Red (Taylor's Version)"
		},
		resonatedLyrics: [
			"And I just wanna tell you",
			"It takes everything in me not to call you",
			"And I wish I could run to you",
			"And I hope you know that every time I don't",
			"I almost do"
		]
	},
	{
		status: "special",
		title: "Credit Card Cleared",
		icon: "credit_card",
		reason: `
			I was *finally* able to get out of my credit card debt today 🎉
			
			I paid off 100,000 Pesos in credit card debt in one fell swoop and I basically cleared everything on it. I called customer support and, annoyingly enough, I had a charge on my credit card that was worth 99 Pesos. Because of the pending charge, I wasn't able to fully close my account.

			This thing has been hanging over my head for more than a year now. I really hate that representative for calling me in October 2022 and for putting me on this path. Sure, it was honestly *my* fault that I got into that debt spiral, but I'm finally glad to have paid it off. Honestly, I'm not gonna use credit cards ever again, or at least not in the forseeable future. That was an **expensive** lesson and I'm glad to have that chapter of my life closed this year.

			It was a good day, too. I was able to play Stardew Valley with my friends in the evening and everything was okay.
		`,
		spotify: {
			artist: "Taylor Swift",
			song: "The Best Day (Stolen Version)",
			link: "https://open.spotify.com/track/7CjuAoOiSrwWv7wJonAUmw?si=de45d88122914aef",
			album: "Fearless (Platinum Edition)"
		},
	},
	{
		status: "above-average",
		reason: `
			Today was a good, fun day. It was like any other day and I had fun in call with my friends.

			In the afternoon, we played The Forest while watching the Big Bang Theory in the background. It was fun, we got to play a lot.
		`,
		spotify: {
			artist: "LE SSERAFIM",
			song: "Good Parts (when the quality is bad but I am)",
			link: "https://open.spotify.com/track/1sZBzYhrQG40zcSuKkI93c?si=8f1beb9af3b24eea",
			album: "ANTIFRAGILE",
		}
	},
	{
		status: "below-average",
		title: "Credit Card Closed",
		icon: "credit_card",
		reason: `
			I finally closed my credit card today! 🥳🎉 I'm glad that's over. Here's to financial freedom for me.

			While I was excited and happy that I was able to close my credit card today, my health slowly started to decline. I tried to read some Reddit posts about people being free from financial debt but I was worried. It's said that every Filipino family is 1 major illness away from financial ruin. Learning that thought scared me because my health is not particularly perfect.

			As the day progressed, my health really started to decline. I kept sneezing and blowing my nose. And at the end, I got this throbbing headache. I tried to feel better in the afternoon by eating sinigang and drinking the soup, but it wasn't working.

			I got to play The Forest with my friends again but it was only short. It was a fun day, regardless, but I felt really sick at the end. I was able to wake my friends up but I didn't accompany them for their night shift anymore because I had to rest.
		`,
	},
	{
		status: "below-average",
		reason: `
			I'm physically sick. I thought I would get better after a full 8 hours of rest, but unfortunately I couldn't. I woke up with a hoarse voice and with my head still hurting. I didn't have the energy to do much today and it seems that I have a fever or so.

			I didn't do much today other than sleep. I tried to watch Gonjiam: Haunted Asylum with my sister in the living room, and took some medicine. That's pretty much it. I'll be taking a leave again tomorrow because I don't feel 100% well enough to go back to work.
		`,
	},
	{
		status: "above-average",
		reason: `
			I'm slowly starting to feel better from being sick yesterday. My mom and sister were gonna go out for some province today so it'll just be me alone in the house for most of the day. I didn't really know what to do, but I just slept more for good measure.

			My day went on as it normally would when I'm alone. I got bored in the afternoon and decided that I deserved a RAM upgrade after going through a lot in the past 2 weeks, and that it's been 2 years overdue. So I ordered 32GB of RAM within the same day and I was able to install it onto my PC. It was really hard, it took me about an hour because I had to clean my PC and it was 15 kilograms, so it was pretty heavy for me to lift on my own.

			Thankfully, I got it to work on one try and I spent the remainder of my day just having fun on my PC, even redesigning the hero banner for my portfolio. And for most of the day, some piano song was stuck in my head.
		`,
		spotify: {
			artist: "Richard Clayderman",
			song: "Les premiers sourires de Vanessa",
			link: "https://open.spotify.com/track/6RhJvQrYWIzrTLs9UAAIC6?si=3a6cc6b8dd2442d1",
			album: "Rondo pour un tout petit enfant"
		},
	},
	{
		status: "good",
		reason: `
			Today was the company's Leader's Appreciation Day and, as a team lead, I got invited in. I'm kinda sure I feel good enough to actually go out, so I did. I got to Romulo Cafe in Makati and some of my friends were there. Colleagues, friends, leaders from other departments. We got to play some games there and eat at a small buffet, which was pretty nice. It was a fun, small get-together for us workmates.

			Around evening, I got home and just watched Hell's Kitchen on my PC. It was a pretty fun evening, too. I realized that my ban from Omegle got lifted and I kinda spent 3 hours of my evening just listening to my friends rant to me about their life. I thought it was going to be like a mutual conversation, but it turned into a one-way trauma dump for 3 hours. NGL, I kinda regretted that and wished that I just watched Hell's Kitchen instead lol. But regardless, it was a pretty good day.
		`,
		spotify: {
			artist: "Little Mix",
			song: "Black Magic",
			link: "https://open.spotify.com/track/6rmXhRIemCTPyMYZRDN7Qg?si=90f43d8c050944c6",
			album: "Get Weird (Expanded Edition)"
		},
		resonatedLyrics: [
			"For a spell that can't be broken",
			"One drop should be enough",
		]
	},
	{
		status: "good",
		title: "Welcome to the Eras Tour (Movie)",
		icon: "tour",
		reason: `
			I got to watch the Eras Tour movie with my friends today! They showed up with an... interesting outfit choice and I was intrigued. But it started well because not a single bad thing happened: no one was late, there were no ticket problems, no food problems. Things were pretty okay. We got to watch it and my friends sang to a lot of the songs in the film, too bad I missed out on most of the albums between 1989 and Midnights. We didn't linger around much after seeing the movie, although I wish we had.

			We had a fun day out and it was okay for me. I was able to talk to some of my friends after getting home. For some reason, I don't feel like I 100% enjoyed it or felt something special, or what. Something felt lacking even though, statistically, nothing was. It made me a bit gloomy in the evening but I didn't show anyone. I just played some games to get my mind off of it.
		`,
		spotify: {
			artist: "The Click Five",
			song: "Jenny",
			link: "https://open.spotify.com/track/3iT4vWUWxqsn4hFTkEaJCi?si=5fc96f1aa207469b",
			album: "Modern Minds and Pastimes (U.S. Version)"
		},
	},
	{
		status: "above-average",
		reason: `
			Everything was just the normal, average Monday today. I got back on the things I have to do at work and play games with my friends.

			In the evening, I had a few rounds of Phasmophobia with my friends but they got hunted by a ghost—a revenant, the fastest ghost there is—and this made them ragequit really bad to the point of uninstalling. We also got to play Project Zomboid after trying to work out some of the kinks and bugs we had at the start of the game. After that, my mom and sister came home and I had to mediate both of them because they were both spiraling into overthinking.

			We got it resolved and that was pretty much it.
		`,
	},
	{
		status: "above-average",
	},
	{
		status: "above-average",
		reason: `
			Today was pretty much normal, fun day. Around evening, I got to play The Forest with my friends because they felt brave enough to explore the other areas of the map and especially the caves. We both ventured onto some random cave and found pretty cool stuff in it. We continued exploring and eventually got out. Killed a few monsters and then we went to cave #2. We got so lost in it and it was such a hard time navigating the map (there wasn't any in-game, I just followed a crude outline via the web). In the end, we both died and restarted from zero. They were pretty annoyed and we both called the game off after losing our progress.

			Thankfully, I know that we saved before dying so we didn't actually lose all our progress and we will be both fine. But regardless, it was a pretty fun game with them.
		`,
		spotify: {
			artist: "Charlene",
			album: "I've Never Been To Me",
			song: "I've Never Been To Me",
			link: "https://open.spotify.com/track/6DMOzL2zPZBAW0LDYCYLWm?si=5b3220c9c89047d7"
		},
		resonatedLyrics: [
			"But I, I took the sweet life I never knew",
			"I'd be bitter from the sweet",
		]
	},
	{
		status: "good",
		reason: `
			My objective for today was to order take-out without my mom noticing. That's why I had to tell her to her face that I was gonna order orange chicken and she cooked it herself. Bless her heart.

			Aside from that secret mission, my day and morning started out normally. The day was an average workday to get through. With me watching a video about the behind the scenes issues that The Exorcist had and finally eating that take-out. I got "beijing beef" from Panda Express and it was pretty underwhelming, to be honest. I kinda regret getting that dish and hoped I picked something else.

			After watching the video and eating, I was playing The Forest with my friends again. We're both relieved that most of our items weren't lost, we didn't really die and just restarted from our last save point. We got to progress a lot and got to clear the cave we died in yesterday. It was overall a pretty fun gameplay and we even had time for Stardew Valley afterward. We got off call and then both continued with our usual stuff for the evening. I got to talk to my mom about things and had some time to kill by watching YT videos and catching up with friends.
		`,
		spotify: {
			artist: "Y-Not",
			album: "Mamma's Boy",
			song: "Average Joe",
			link: "https://open.spotify.com/track/35QpMgp1pheSPJegwzdg5e?si=9b0ec5fc96344901"
		},
		resonatedLyrics: [
			"And I said, \"Hey girl, why can't you just love me",
			"I know I'm just your average Joe\"",
			"But if you take some time to get to know me",
			"So what's your name, hi my name is Joe",
		]
	},
	{
		status: "bad",
		reason: `
			The day actually went through normally and, since it was a Friday, I was really happy about a lot of things. I looked forward to the weekend and I had to make it through 1 last workday. Today was pretty normal, as far as things are. But it's the evening that really made things bad.

			I got off work as usual and my evening proceeded as it normally would. I was in a call with my friends and we both started playing our usual game of The Forest. We both cleared up a lot of caves at this point and got the keycard we need to complete the final mission. They asked me if I wanted to clear the game tonight and we both agreed to go. But then they had to leave immediately and I decided to play Wangan Midnight at the arcade in BGC instead.
			
			I still wasn't okay. I just went home to watch a new episode of Loki Season 2. I didn't really feel that bad at the end, but I was just anxious and it pulled at a part of me which I'm trying to fix and grow from.
		`,
		spotify: {
			artist: "Nanou",
			album: "ハロ／ハワユ",
			song: "ハロ／ハワユ",
			link: "https://open.spotify.com/track/1CEC3JNSQy8OQXmnuLcA1D?si=7116eba97278418b"
		},
	},
	{
		status: "special",
		title: "The Saturday I’ve Waited For! 🎉",
		icon: "nightlife",
		reason: `
			### TODAY IS THE DAY: SATURDAY!!!!!!

			My God, today is actually **really packed**, holy shit. I have these 2 major events going on today:

			- Hanging out with Rachel at the National Museum.
			- Setting up my things at the Airbnb later this evening.
			- Going to a bar/club with Maxine, Meryll, and Ate Cha.

			I had to wake up early and, even though my spirits still weren't okay from last night, I need to get through this day and make the most out of it. I woke up early and got a good amount of sleep in the morning. Then I commuted to Manila to meet with Rachel. It's been months since we've last met and have known each other for years, I'm glad to actually see them and spend a good chunk of the day with them. We got to meet at around the United Nations MRT station and walked around the National Museum of Natural History. They described some rocks and other geology stuff because they were taking BS Geology and we had fun at the first museum. After going there, we both agreed that we were feeling hungry so we went to SM City Manila to have some late lunch (it was around 2:00 p.m. by then). I'm surprised that they... treated me to lunch. I've been a giver for a long time and I've rarely been treated out/appreciated properly, so it was such a really nice gesture that they offered to buy me food. We both finished our meals and then went back museum-hopping.

			We stopped by the National Museum of Fine Arts because their outfit was themed for the Spoliarium exhibit. We took a lot more photos in there, which they really liked. Then Rachel started having really bad cramps on their leg and they almost passed out from the pain. I called a security guard and then they had to go home. Thankfully, they seemed okay and got home safe because they got a ride home using Grab.

			After they got home, that was my cue for my next event for the day: my Airbnb stay and partying with Max, Meryll, and Ate Cha.

			I tried to move as quick as I can: booking a ride home immediately, preparing my stuff, and getting freshed up once again for the evening. It was a really tight time for me, but I think I moved as fast as I could. I got to the Airbnb and there they were! I was so happy to meet them and was excited for the night.

			Before partying, we all had dinner at this Persian restaurant along Poblacion and I gotta say, it was really good. The beef kebab is something I'm definitely ordering again in the future. We all had some small talk and then a few conversations about each's love lifes and then we finished dinner. We all got dressed and prepared, then headed out of the Airbnb to The Fun Roof in Poblacion.

			It was really fun there. We got a lot of alcoholic drinks and our table was good enough. We danced a lot throughout the entire evening and had some time talking amongst ourselves wherever possible. It was too loud inside, though. The music was blasting and we really couldn't hear each other talk clearly. Still, it was fun. We played some card game, got to drink out of a weird achohol ferris wheel drink stand, and got to dance to some songs. Nothing else noteworthy happened, aside from me slipping and almost injuring my ankle.

			We all returned to the Airbnb for a good night's rest, even though it was 4 a.m. in the following day and that wrapped up my exciting Saturday.
		`,
		spotify: {
			artist: "Git Fresh",
			album: "Booty Music",
			song: "Booty Music - Album Version (Edited)",
			link: "https://open.spotify.com/track/46E0Viezr6IhLFbQ2YfGbcq"
		},
	},
	{
		status: "good",
		reason: `
			In the morning, we all woke up at around 9 a.m. to have the complimentary breakfast that was provided with our stay. I ordered eggs, toast, and hotdogs with coffee for my breakfast meal. It was pretty good and I actually wasn't able to finish it without taking a long time to eat.

			Meanwhile, my friends were calling me in the morning, after telling my friends that we'll play later, I continued my day by going out with my family and we tried to find this old Japanese restaurant from when I used to work in Makati, only to find it closed and the entire restaurant business had shut down. We ate at another Japanese restaurant but it wasn't as good. We strolled around for a bit more in the mall, got Starbucks, and went home.

			When I got home, I got to play The Forest with my friends and it was a fun evening, with us joking around and doing our usual routine.
		`,
		spotify: {
			artist: "Taylor Swift",
			album: "The Taylor Swift Holiday Collection",
			song: "Christmas Must Be Something More",
			link: "https://open.spotify.com/track/31JVjy3XWnh6C2zf4kLCXN?si=2afccf3152844dd0"
		},
	},
	{
		status: "above-average",
		reason: `
			It was your usual Monday for me, with me playing The Forest with my friends in the evening and we started to look for a new place to build a base on.
		`,
		spotify: {
			artist: "AJR",
			song: "Way Less Sad",
			link: "https://open.spotify.com/track/6YIivt0G3ZUuNrM62jp9pL?si=70925e0fe4204306",
			album: "OK ORCHESTRA"
		},
	},
	{
		status: "above-average",
		reason: `
			I got introduced by Ane into their friend group and I got to talk to some of their friends. I played poker on Discord with them and it was pretty fun. They seem like the RC and it was fun to hang around with them.
		`,
		spotify: {
			artist: "Jeremy Zucker",
			song: "comethru",
			link: "https://open.spotify.com/track/18uwL0vNUanqZH0ro2QcOP?si=826ea439e49f463d",
			album: "summer,"
		},
		resonatedLyrics: [
			"Now I'm shaking, drinking all this coffee",
			"These last few weeks have been exhausting",
		]
	},
	{
		status: "above-average",
		reason: `
			my friends played some songs from Frozen 2's soundtrack today and, whew, it sure sent *chills* down my spine. Not because it was a cool soundtrack, but because it reminded me of a time when I was deeply into them. When I played some of the songs, it took me back to that time in January-February 2022, and I still remember how we both watched Frozen 2 in early February.

			It pulled on a sense of nostalgia for me that I couldn't explain. But know one thing for sure: I miss the feeling of being in love. Like I had my friends and something good to look forward to. Even though I deeply miss those days, it's unlikely that they'll come back. Listening to this soundtrack really tugs on my heartstrings.
		`,
		spotify: {
			artist: "Jonathan Groff",
			song: "Lost in the Woods",
			link: "https://open.spotify.com/track/7namdlOhbtsc8FvoSafOQt?si=a9a469df508c424f",
			album: "Frozen 2 (Original Motion Picture Soundtrack/Deluxe Edition)"
		},
	},
	{
		status: "excellent",
		title: "Sister's Graduation 🎓",
		icon: "school",
		reason: `
			I was up early in the morning to attend my sister's graduation. I'm glad that they were actually able to reach this point in their life and it seems to be the end of their academic life. Finally! So that's done.

			The speaker for the graduation event was someone who didn't go through the usual route of formal education and they went down the path of working instead, something I resonated deeply with as a college dropout who had to work in their teens. Hearing their story was inspiring, and so was the entire graduation ceremony itself. It's honestly very unlikely that I'll graduate so this will be my only experience of a college graduation. I got up on the stage along with my sister and mom, and I got to see my sister bid farewell to their friends.

			For the evening, we got to eat at some steakhouse and that made me feel too full, despite barely eating anything the whole day. Maybe the "well done" steak wasn't my thing. When I got home, I got to play The Forest with my friends and we found a new place to set up a base on. It was a difficult choice to move bases, but it was fun setting up everything.
		`,
		spotify: {
			artist: "DJ Khaled, Justin Bieber, Quavo, Chance the Rapper, Lil Wayne",
			song: "I'm the One",
			link: "https://open.spotify.com/track/3DXncPQOG4VBw3QHh3S817?si=89dcf9c965594ae5",
			album: "Grateful"
		},
	},
	{
		status: "below-average",
		reason: `
			When I woke up, I felt really bad. I had a small cough yesterday and it turned into a full-blown cough with phlegm today. I thought I could power through work today and I was able to attend 2 meetings in the morning, but during the second one, I lost consciousness and missed a morning meeting. When I woke up, I decided that I really wasn't okay and that powering through today will only cause me more pain and it might render me bedridden for tomorrow's family outing.

			I decided to file for a sick leave from work and then rested the whole day. I ate and then got to watch episode 4 of Loki Season 2. It was mind-blowing, honestly. I have never been so gripped by the ending of an episode so much. I don't remember much after that.
		`,
		spotify: {
			artist: "Kidz Bop Kids",
			song: "Anti-Hero",
			link: "https://open.spotify.com/track/0ny7P1jlyZXkvvsSfE3cTe?si=ff02110d3eaf49b4",
			album: "KIDZ BOP 2023"
		},
		resonatedLyrics: [
			"Sometimes I feel like everybody is a little baby",
			"And I'm a monster on the hill",
			"Too big to hang out, slowly lurching toward your favorite city",
			"Straight through the heart but never thrilled"
		]
	},
	{
		status: "special",
		title: "Beach Episode 🏖️",
		icon: "beach_access",
		reason: `
			Today's another Saturday to look forward to! I'm *finally* gonna go out of the house again to go to the beach! ⛱

			I was so excited for it and I got woken up really early. When I finished preparing with my family, we got into the van my cousin rented. It was kind of quick trip to Bantangas and I had mobile data with me throughout the entire journey, so I was able to catch up on the latest song from LE SSERAFIM and I really liked it. I got to play some Linkin Park songs as well, but it was a very peaceful ride out from Metro Manila, Tagaytay, then Batangas. When we got to the parking lot, we got our stuff and I saw the beach. It was *awesome*, honestly. I haven't seen the beach in almost forever. I think the last time I went to the beach was in 2019 or so with my past company's outing.

			The place we stayed at wasn't that great, it looked really cheap and a lot of vendors were always swarming the area. It was a very public space and the rooms were kinda unkempt, but it was fine since I'm joining this for free. I got to swim in the beach shortly after, even though it was under the scorching sun at noon. The water was really cold and it's been a while since I've tasted saltwater, so it was kind of a fun, new-ish experience.

			Around later in the afternoon, I got to go snorkeling with my mom, sister, and some of my other family members. I was actually scared to get my Samsung Note 20 Ultra in the water because it had already suffered from water damage. I tried to take some photos and videos while diving underwater, but I didn't dove deep and my phone was kind of malfunctioning while the video was recording. We also got to ride a banana boat ride and got tossed out to the water by the end of it. It was fun and it was horrible because I was placed at the front. I couldn't see anything because the seawater from the jetski kept hitting my face. But we had a fun ride regardless.

			I also took more photos of my cousins and their friends while in the water. I threw caution to the wind and use my phone bare, even splashed it across the water to show off/scare people who were looking after my phone. I got to rest after than and then ate some really good food that they were cooking. They had everything and what I liked the most was either the grilled *liempo* or *sisig*. It was a lot of really, really good food and I felt full afterward. My sister and I also had some slight panic session when we thought mom was missing, but they were actually just shopping around the area.

			I drank some coffee during that time and then went back to my sleeping quarters to talk to Max about life and a bunch of other things. Overall, it was fun, I got to sleep at around 2 a.m. and it was a pretty solid, special day outside. October really has a way of packing great events into one month, honestly. Best October of my life so far.
		`,
		spotify: {
			artist: "LE SSERAFIM",
			song: "Perfect Night",
			link: "https://open.spotify.com/track/74X2u8JMVooG2QbjRxXwR8?si=28ad08132d544641",
			album: "Perfect Night"
		},
		resonatedLyrics: [
			"Come and take a ride with me",
			"I got a credit card and some good company",
			"Some come through",
			"Make the fit real good",
			"Why you still stuck on loading?",
			"Waitin' on you, babe"
		]
	},
	{
		status: "above-average",
		reason: `
			I barely slept last night but I also woke up early, around 7 a.m. or so. Today's the day where our beach trip ends and we go back to our homes. My family members told me to enjoy the beach and swim, but I just politely declined since I don't want to go through the hassle of changing clothes to swim. So just walked along the shoreline and talked to myself, thinking about other things in life and where mine's headed. After packing my bags and taking our last photos, we went home.

			The ride home was hot as hell and very uncomfortable since it was almost close to noon. I couldn't sleep that much during the trip, so I just watched more K-Pop videos. When I got home, it felt so nice to actually go back to my "battle station" and to see my room again. I got some rest, talked to friends, and mostly spent most of my evening alone. So I just spent some of my time talking to Kai.
		`,
		spotify: {
			artist: "DJ Khaled, Justin Bieber, Quavo, Chance the Rapper, Lil Wayne",
			song: "I'm the One",
			link: "https://open.spotify.com/track/3DXncPQOG4VBw3QHh3S817?si=89dcf9c965594ae5",
			album: "Grateful"
		},
	},
	{
		status: "above-average",
		reason: `
			Today was pretty fun. I played The Last of Us while my friends watched. I also played Phasmophobia with friends from work. The Halloween update was pretty fun. It was a good day, even though I tried to go out and unsuccessfully play at the arcades today.
		`,
		spotify: {
			artist: "Lecrae, Boi-1da",
			song: "Where We Come From",
			link: "https://open.spotify.com/track/2IjthaptX4H9KQwEj52Bqx?si=9ace609ace8b4a25",
			album: "Where We Come From"
		},
	},
	{
		status: "above-average",
		reason: `
			I had a fun day with my friends today. We mostly just played games and we tried Moving Out, it was pretty fun but we both got frustrated when we weren't able to place this thing perfectly in the truck.
		`,
		spotify: {
			artist: "Taylor Swift",
			album: "Lover",
			song: "Daylight",
			link: "https://open.spotify.com/track/1fzAuUVbzlhZ1lJAx9PtY6?si=cf87479597b84060"
		}
	},
];

export default octoberMap;
